<template>
	<section class="app-main">
		<el-row type="flex" justify="center">
			<el-col :xs="23" :sm="22" :md="22" :lg="21" :xl="20">
				<transition name="fade" mode="out-in">
					<router-view :key="key"></router-view>
				</transition>
			</el-col>
		</el-row>
	</section>
</template>

<script>
export default {
    name: "AppMain",
    index: "",
    computed: {
        key() {
            return this.$route.name !== undefined
                ? this.$route.name + +new Date()
                : this.$route + +new Date();
        }
    }
};
</script>

<style>
.app-main {
    margin: 20px auto;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/AppMain.vue